var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reactome-wrapper",attrs:{"id":"reactome-wrapper"}},[(_vm.reactomeId)?_c('div',{staticClass:"row",attrs:{"id":"reactome-div"}}):_c('div',[_c('h6',[_vm._v("No Reactome ID")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }